import APIClient from '@/shared/http/clients/api'
import APIClientUpload from '@/shared/http/clients/apiupload.js'

const resourceName = 'planilhas'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}&sort=dataEnvio,desc`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const GetReportById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}/report`, config)
const GetReportShareById = (id, config = {}) => APIClient.post(`${APICore}/${resourceName}/${id}/report/share`, config)
const Create = (data = {}, config = {}) => APIClientUpload.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?${document}&page=${index}&size=${limit}&sort=dataEnvio,desc`, config)
const CancelImport = (id, config = {}) => APIClient.put(`${APICore}/${resourceName}/${id}/cancel`, config)

const ImportsRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  GetReportById,
  GetReportShareById,
  Create,
  Update,
  Delete,
  Search,
  CancelImport
}

export default ImportsRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/imports.js